export const initialState = {
  actionProcessing: false,
  users: [],
  selectedAgentId: null,
  agentClickedTrigger: {},
  parentTree: [],
  searchTree: '',
};
